import React, {JSX, ReactElement} from 'react';
import {
    Edit,
    SimpleForm,
    TextField,
    Datagrid,
    EditButton,
    SelectInput,
    FormDataConsumerRenderParams,
    ReferenceInput,
    AutocompleteInput,
    FormDataConsumer,
    DateField,
    TextInput,
    ReferenceManyField,
    Pagination,
} from 'react-admin';
import {
    Grid,
    Box,
} from '@mui/material';
import { complianceSnifferTypes, complianceSnifferResultsStatus } from "../../defaults/defaults";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";
import { NokProcessingFailurePanel } from "./components/NokProcessing/NokProcessingFailurePanel";

export const ComplianceSnifferResultsEdit: () => JSX.Element = (): JSX.Element => {

    return (
        <Edit
            actions={ false }
        >
            <SimpleForm>
                { /* Above the form, and only present when there is something to say.
                     Someone opening a result that shows no scores needs to know why
                     before they start reading the fields for a reason. */ }
                <NokProcessingFailurePanel mini="cs" />
                <Grid container spacing={ 2 } sx={ { width: '100%' } }>
                    <Grid size={ 6 }>
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } }>
                            <span>{ "ID" }</span>
                            <TextField source="id" />
                        </Box>
                        <SelectInput source="status" choices={ complianceSnifferResultsStatus } />
                        <ReferenceInput source="complianceSniffer" reference="compliance_sniffers">
                            <AutocompleteInput />
                        </ReferenceInput>

                        <SelectInput source="type" choices={ complianceSnifferTypes } />
                        <FormDataConsumer<{ type: string }>>
                            {({
                                  formData,
                                  scopedFormData,
                                  ...rest
                              }: FormDataConsumerRenderParams<{ type: string }>): ReactElement|null => {
                                if (formData?.type?.toLowerCase() === 'customer') {
                                    return (
                                        <Box sx={ {
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        } } >
                                            <h3>{ "Employee" }</h3>
                                            <ReferenceInput source="employee" reference="employees">
                                                <AutocompleteInput />
                                            </ReferenceInput>
                                        </Box>
                                    );
                                }
                                return null;
                            } }
                        </FormDataConsumer>
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } } >
                            <span>{ "Created" }</span>
                            <DateField source="createdAt" showTime />
                        </Box>
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } } >
                            <span>{ "Updated" }</span>
                            <DateField source="updatedAt" showTime />
                        </Box>
                    </Grid>
                    <Grid size={ 6 }>
                        <Box sx={ {
                            display: 'flex',
                            flexDirection: 'column'
                        } } >
                            <h3>{ "Emails" }</h3>
                            <ReferenceManyField source="emailMessages"
                                                pagination={ <Pagination /> }
                                                perPage={ 10 }
                                                reference="email_messages" target="id">
                                <Datagrid bulkActionButtons={ false } >
                                    <TextField source="id" />
                                    <TextField source="subject" />
                                    <DateField source="createdAt" showTime />
                                    <EditButton label="View" />
                                </Datagrid>
                            </ReferenceManyField>
                        </Box>
                        <Box sx={ {
                            display: 'flex',
                            flexDirection: 'column'
                        } } >
                            <h3>{ "Mini Grades" }</h3>
                            <ReferenceManyField source="miniGrades"
                                                pagination={ <Pagination /> }
                                                perPage={ 10 }
                                                reference="mini_grades" target="id">
                                <Datagrid bulkActionButtons={ false } >
                                    <TextField source="id" />
                                    <TextField source="name" />
                                    <TextField source="finalScore" />
                                    <DateField source="createdAt" showTime />
                                    <EditButton label="View" />
                                </Datagrid>
                            </ReferenceManyField>
                        </Box>
                    </Grid>
                </Grid>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}
